export const DASHBOARD_FEATURES = Object.freeze({
  apiPlayground: 'dashboard.apiPlayground',
  marketplace: 'dashboard.marketplace',
  mcpManagement: 'dashboard.mcpManagement',
  oiAnalysis: 'dashboard.oiAnalysis',
  optionsBuilder: 'dashboard.optionsBuilder',
  optionsAnalytics: 'dashboard.optionsAnalytics',
  screener: 'dashboard.screener',
  statusPage: 'dashboard.statusPage',
})

export const EVALUATED_FEATURES_CACHE_TTL_MS = 5 * 60 * 1000

/**
 * Resolve a feature flag from the server-evaluated configuration.
 *
 * Configuration stays fail-closed until the server identifies the active
 * environment. Once evaluation succeeds, unregistered flags preserve the
 * platform's default-on behavior.
 */
export function isEvaluatedFeatureEnabled(evaluatedFeatures, featurePath) {
  const featureMap = evaluatedFeatures?.features
  const environment = evaluatedFeatures?.env

  if (
    typeof environment !== 'string' ||
    !environment.trim() ||
    environment === 'unknown' ||
    !featureMap ||
    typeof featureMap !== 'object'
  ) {
    return false
  }

  return featureMap[featurePath] ?? true
}
